export enum FocusedSectionActions {
  SET_FOCUSED_SECTION = 'SET_FOCUSED_SECTION',
  REMOVE_FOCUSED_SECTION = 'REMOVE_FOCUSED_SECTION',
}
